import { useEffect, useMemo, useState } from "react";
import { createTheme, useMediaQuery } from "@mui/material";

export default function useTheme() {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const storedTheme = localStorage.getItem("darkMode");

  const [darkMode, setDarkMode] = useState(
    storedTheme ? JSON.parse(storedTheme) : prefersDarkMode
  );

  // Sync with localStorage and update body class
  useEffect(() => {
    localStorage.setItem("darkMode", JSON.stringify(darkMode));

    if (darkMode) {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }
  }, [darkMode]);

  // Build the MUI theme based on darkMode
  const theme = useMemo(
    () =>
      createTheme({
        typography: {
          fontFamily: "Open Sans, sans-serif",
        },
        palette: {
          mode: darkMode ? "dark" : "light",
          primary: { main: "#035CB8" },
          secondary: { main: "#FFC72C" },
          background: {
            default: darkMode ? "#121212" : "#ffffff",
            paper: darkMode ? "#1E1E1E" : "#f5f5f5",
          },
          text: {
            primary: darkMode ? "#ffffff" : "#000000",
            secondary: darkMode ? "#b0b0b0" : "#333333",
          },
        },
      }),
    [darkMode]
  );

  return { darkMode, setDarkMode, theme };
}
